import { render, staticRenderFns } from "./TransferAbnormal.vue?vue&type=template&id=75211891&scoped=true&"
import script from "./TransferAbnormal.vue?vue&type=script&lang=js&"
export * from "./TransferAbnormal.vue?vue&type=script&lang=js&"
import style0 from "./TransferAbnormal.vue?vue&type=style&index=0&id=75211891&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75211891",
  null
  
)

export default component.exports